import { render, staticRenderFns } from "./InvoiceInfo.vue?vue&type=template&id=2e8708aa&scoped=true&"
import script from "./InvoiceInfo.vue?vue&type=script&lang=js&"
export * from "./InvoiceInfo.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceInfo.vue?vue&type=style&index=0&id=2e8708aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8708aa",
  null
  
)

export default component.exports